<template>
    <div v-if="!isLoading" class="pt-5">
      <!-- <div class="text-center my-3">
        <img :src="streamFileUrl + workspace.operatingCenterLogo" alt="" class="rounded-circle" style="width: 15rem; height: 15rem">
      </div> -->
      <div class="text-center my-3">
        <h3 class="text-warning text-uppercase">{{ workspace.operatingCenterName }}</h3>
      </div>
      <div class="container-fluid" id="listReportItem">
        <router-link v-for="report in reports" :key="report.id" :to="'/report-viewer?reportId=' + report.id" target="_blank" size="sm" class="">
          <div class="card" style="/*background-color: #2be9cf7a;*/">
            <div class="content">
              <div class="img">
                <img :src="(report.imageUrl != null && report.imageUrl.trim().length > 0 ) ? streamFileUrl + report.imageUrl : require('@/assets/default-report.png')">
              </div>
              <div class="cardContent">
                <h3>{{ report.reportName }}</h3>
              </div>
            </div>
          </div>
        </router-link>
      </div>
    </div>
    <Loading :active="isLoading" class="text-center" color="#000000" loader="spinner"></Loading>
</template>
  
<script>
import {mapActions} from 'vuex';
import config from '@/config/prod.env';
import Loading from "vue3-loading-overlay";
export default {
    name: "TheOperatingCenter",
    components: {
      Loading
    },
    data() {
      return {
        isLoading: true,
        workspaceId: null,
        workspace: null,
        streamFileUrl: null,
        reports: [],
      }
    },
    methods: {
      ...mapActions('report', ['getActiveReportByWorkspaceId']),
      ...mapActions('workspace', ['getWorkspaceById', 'getWorkspaceByRoleIds']),
      setup() {
        this.streamFileUrl = process.env.VUE_APP_STREAM_FILE_URL;
        this.workspaceId = this.$route.query.workspaceId;
      },
      async getData() {
        // get workspace
        let rs1 = await this.getWorkspaceById(this.workspaceId);
        if(rs1.isOk) {
          this.workspace = rs1.data.data;

          // check permission
          let user = JSON.parse(localStorage.getItem('login_info'));
          let roleIds = user.roleInfo.map(e => e.id);
          let rs = await this.getWorkspaceByRoleIds(roleIds);
          if(rs.isOk) {
            let workspaceIds = rs.data.data.map(e => e.id);
            if(!workspaceIds.includes(this.workspaceId)) {
              this.$router.push("/admin");
            }
          } else {
            this.$router.push("/admin");
          }

          // check isUsePBIHome
          if(this.workspace.isUsePBIHome) {
            this.$router.push(`/report-viewer?reportId=${this.workspace.reportId}`);
          }
        }

        // get reports
        let rs2 = await this.getActiveReportByWorkspaceId(this.workspaceId);
        if(rs2.isOk) {
          this.reports = rs2.data.data;
        }
        this.isLoading = false;
      }
    },
    mounted() {
      this.setup();
      this.getData();
    },
    created() {
     
    }
};
</script>
  
<style lang="scss" scoped>
$colors: (
  one:     #990033,
  two:     #161623,
  
  negro:  #020202,
  blanco: #ffffff,
  sombra: #000000
);

@function color($color-name) {
  @return map-get($colors, $color-name);
}

@mixin displayFlex($justify,$align,$direction) {
  display: flex;
  justify-content: $justify;
  align-items: $align;
  flex-direction: $direction;
}

@keyframes colorful{
  0% {
    filter: hue-rotate(0deg);
  }
  100% {
    filter: hue-rotate(360deg);
  }
}

*,
*::before,
*::after {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  text-decoration: none;
  list-style: none;
  outline: none;
  appearance: none;
  border-style: none;
  color: color(blanco);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

h1,h2,h3,span,p {
  font-family: "Montserrat", -apple-system, BlinkMacSystemFont, "Segoe UI",
    "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans",
    "Helvetica Neue", sans-serif;
}

body {
  position: relative;
  overflow: hidden;
  @include displayFlex(center, center, column);
  padding: 2em;
  
  &::-webkit-scrollbar {
    background: color(negro);
    width: 10px;
  }
  &::-webkit-scrollbar-track {
    background: color(negro);
  }
  &::-webkit-scrollbar-thumb {
    background: color(blanco);
    border-radius: 1px;
  }
  
  #listReportItem {
    position: relative;
    z-index: 1;
    @include displayFlex(center, center, row);
    flex-wrap: wrap;
    padding: 1em;
    
    .card {
      position: relative;
      width: 15rem;
      height: 15rem;
      margin: .5em;
      background: rgba(255,255,255,0.05);
      box-shadow: 0 15px 35px rgba(0,0,0,.2);
      border-radius: 15px;
      @include displayFlex(center, center, column);
      backdrop-filter: blur(40px);
      
      border: solid 2px transparent;
      background-clip: padding-box;
      box-shadow: 0px 10px 10px rgba(46, 54, 68, 0.03);
      
      .content {
        position: relative;
        @include displayFlex(center, center, column);
        opacity: 0.9;
        transition: 0.5s;
        
        .img {
          position: relative;
          width: 6rem; height: 6rem;
          // border-radius: 50%;
          overflow: hidden;
          // border: 10px solid rgba(0,0,0,.25);
          
          img {
            position: absolute;
            top: 0; left: 0;
            width: 100%; height: 100%;
            object-fit: cover;
          }
        }
        
        .cardContent {
          h3 {
            color: #fff;
            text-transform: uppercase;
            letter-spacing: 2px;
            font-weight: 500;
            font-size: 18px;
            text-align: center;
            margin: 20px 0 10px;
            line-height: 1.1em;
            
            span {
              font-size: 12px;
              font-weight: 300;
              text-transform: initial;
            }
          }
        }
      }
      
      .sci {
        position: absolute;
        bottom: 50px;
        @include displayFlex(center, center, row);
        
        li {
          margin: 0 10px;
          transform: translateY(40px);
          opacity: 0;
          transition: 0.5s;
          transition-delay: calc(0.1s * var(--i));
          
          a {
            font-size: 24px;
          }
        }
      }
      
      &:hover .content {
        opacity: 1;
        transform: translateY(-20px);
      }
      
      &:hover .sci li {
        transform: translateY(0px);
        opacity: 1;
      }
    }
  }
}
</style>